/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';

// Proptype
import PropTypes from 'prop-types';

// Components
import { withStyles, Stepper, Step, StepLabel, StepButton, Typography } from '@material-ui/core';
import { CancelApplicationModal, ADGMImage, Loading } from 'aurora-components';
// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { discardApplication } from 'aurora-composition/modules/application/actions';

// Styles
import styles from './styles';

// SVG

function StepperV2({
  classes,
  steps,
  handleStep,
  activeStep,
  application,
  cancelApplicationParams,
  hideCancelBtn,
  hideSteps,
  title,
  children,
}) {
  const dispatch = useDispatch();
  const { loading } = useSelector(state => state.applicationReducer);
  const [isCancelApplicationModalOpen, setIsCancelApplicationModalOpen] = useState(false);
  return (
    <>
      {loading && <Loading />}
      <div className={classes.mainContainer}>
        <div className={classes.initiatorFlowHeader}>
          {keyEmptyCheck(title || application?.applicationDetails?.applicationType || application?.applicationType)}
        </div>
        {!hideSteps && (
          <div className={classes.StepperContainer}>
            <div className={classes.applicationStepsInitiator}>
              <div className={classes.StepperInnerContainer}>
                {/* <div className={classes.StepperHeader}>
              <Typography variant='h5' className={classes.StepperTitle}>
                {customTitle || keyEmptyCheck('application_steps')}
              </Typography>
              {!hideCancelBtn && (
                <ADGMImage
                  name='trash_red.svg'
                  alt='trash'
                  onClick={() => {
                    setIsCancelApplicationModalOpen(true);
                  }}
                />
              )}
            </div> */}
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  orientation='horizontal'
                  connector={<></>}
                  classes={{
                    vertical: classes.stepperopnerList,
                  }}
                >
                  {steps?.map((label, index) => (
                    <Step key={label} className={classNames(classes.RootStep, steps?.length <= 3 && classes.flex1)}>
                      <StepButton
                        onClick={() => handleStep(index)}
                        completed={activeStep > index}
                        classes={{
                          root: classNames({
                            [classes.stepButtonComplete]: activeStep > index,
                            [classes.ACTIVE]: activeStep === index,
                          }),
                        }}
                      >
                        <StepLabel
                          classes={{
                            root: classes.MuiStepLabelRoot,
                            label: classes.label,
                            active: classes.labellistActive,
                            iconContainer: classes.MuiStepLabeliconContainer,
                          }}
                          StepIconProps={{
                            classes: {
                              root: classes.listingiconRoot,
                              // text: classes.completed,
                              // active: classes.activeIcon,
                            },
                          }}
                        >
                          {index + 1} {keyEmptyCheck(label)}
                        </StepLabel>
                      </StepButton>
                      <div className={classes.stepProgressImgContainer}>
                        {index === activeStep && <ADGMImage name='active_icon.svg' alt='Active Step' />}
                        {activeStep > index && <ADGMImage name='completed_icon.svg' alt='Completed Step' />}
                        {activeStep < index && <ADGMImage name='steps_icon.svg' alt='Remaining Steps' />}
                      </div>
                    </Step>
                  ))}
                </Stepper>
              </div>
              {children}
            </div>
            <div className={classes.countBlock} style={{ alignSelf: 'center' }}>
              <Typography className={classes.stepsCount} style={{ direction: 'ltr' }}>
                {activeStep + 1} / {steps?.length}
              </Typography>
            </div>
          </div>
        )}
      </div>
      {!hideCancelBtn && (
        <CancelApplicationModal
          open={isCancelApplicationModalOpen}
          onClose={() => setIsCancelApplicationModalOpen(false)}
          cancelApplication={() => {
            setIsCancelApplicationModalOpen(false);
            dispatch(
              discardApplication(
                application?.applicationDetails?.applicationId ?? application?.applicationId,
                application,
                cancelApplicationParams,
              ),
            );
          }}
        />
      )}
    </>
  );
}

StepperV2.propTypes = {
  steps: PropTypes.array.isRequired,
  handleStep: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  hideCancelBtn: PropTypes.bool,
  cancelApplicationParams: PropTypes.any,
  // eslint-disable-next-line react/no-unused-prop-types
  customTitle: PropTypes.any,
  children: PropTypes.any,
  title: PropTypes.string,
  hideSteps: PropTypes.bool,
};

StepperV2.defaultProps = {
  title: '',
  hideCancelBtn: false,
  cancelApplicationParams: null,
  customTitle: null,
  children: null,
  hideSteps: false,
};

export default withStyles(styles)(StepperV2);
